import type { BackendModule } from "i18next";

import { PSEUDO } from "./detect";

export type BundleLoaders = Record<string, () => Promise<{ default: Record<string, unknown> }>>;

/** An i18next backend over Vite's lazy ``import.meta.glob`` loaders
 *  (keyed ``./locales/<code>.json``). ``pseudoSource`` is the catalog the
 *  ``en-XA`` pseudo-locale is generated from. */
export function createLazyBackend(
  loaders: BundleLoaders,
  pseudoSource: Record<string, unknown>,
): BackendModule {
  return {
    type: "backend",
    init() {},
    read(lng, _ns, callback) {
      if (lng === PSEUDO) {
        import("@repoworks/i18n-languages/tools/pseudo.mjs").then(
          (m) => callback(null, m.pseudoize(pseudoSource)),
          (e: unknown) => callback(e as Error, null),
        );
        return;
      }
      const load = loaders[`./locales/${lng}.json`];
      // Unknown or English: nothing to fetch; English is bundled and
      // every missing key falls back to it. Never throw.
      if (!load) {
        callback(null, {});
        return;
      }
      load().then(
        (m) => callback(null, m.default),
        (e: unknown) => {
          // A 404'd chunk (a stale SPA after a deploy) must not keep the
          // app from rendering: i18nReady still resolves, in English.
          console.warn(`i18n: failed to load ${lng}`, e);
          callback(e as Error, null);
        },
      );
    },
  };
}
